import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Persistent File Storage/formats";
import * as React from 'react';
export default {
  Content,
  React
};